var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStep4Bar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1147.55 34.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00adef;\n      }\n\n      .cls-2 {\n        fill: #a8e3fa;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 23.71,
    y1: 17.32,
    x2: 1114.35,
    y2: 17.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#a8e3fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#6ed0f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#3ec1f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1cb6f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#07afef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00adef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 23.71,
    y: 11.19,
    width: 1090.64,
    height: 12.28
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 13.43,
    cy: 17.32,
    r: 13.43
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1140.18 17.32 1127.16 28.39 1127.16 34.65 1147.55 17.32 1127.16 0 1127.16 6.26 1140.18 17.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1127.16 17.32 1114.35 6.44 1114.35 28.21 1127.16 17.32"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 384.54,
    cy: 17.32,
    r: 13.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 755.65,
    cy: 17.32,
    r: 13.43
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep4Bar);
export default __webpack_public_path__ + "static/media/Step4_bar.ffb66300499bae122175a68f59338073.svg";
export { ForwardRef as ReactComponent };